import { AsyncThunk, createAsyncThunk, createSlice } from "@reduxjs/toolkit"

import { filterDataAPIv1 } from "services/CRUDServices"
import { filterUrls } from "services/api.enums"
import { StateData } from "./state-model"
import { getShamsiDateWithMonthOffset, getToday } from "tools/functions/Methods"

export const FilterConsignment: AsyncThunk<{}, {}, {}> = createAsyncThunk(
  "consignment",
  async (body: any) => {
    let { data } = await filterDataAPIv1(
      filterUrls.newConsignment,
      {
        ...body,
        pageNumber: undefined,
        pageSize: undefined,
      },
      body.pageNumber,
      body.pageSize,
      [
        {
          property: "id",
          direction: "DESC",
        },
      ]
    )

    return data.response
  }
)

const initialState: StateData = {
  filter: {
    isActive: true,
    createdDate: {
      fromDate: { ...getShamsiDateWithMonthOffset(-1), hour: 0, minute: 0 },
      toDate: { ...getToday(true), hour: 23, minute: 59 },
    },
  },
  selectedTable: [],
  selectedRow: [],
  consignments: [],
  fetchpost: false,
}

const ConsignmentReducer = createSlice({
  initialState: initialState,
  name: "consignment",
  reducers: {
    setFilter: (state, action) => {
      state.filter = action.payload
    },
    selectedTableAction: (state, { payload }) => {
      const convertData = payload?.map((item) => ({ ...item, operation: "" }))
      const premiere = convertData

      const check = premiere.filter((item) =>
        [4, 21, 24, 23].includes(item.statusId)
      )
      const selectedCards = [...state.selectedTable, ...check]
      if (check.length !== 0) {
        //@ts-ignore
        const jsonObject = selectedCards.map(JSON.stringify)

        const uniqueSet = new Set(jsonObject)
        //@ts-ignore
        const uniqueArray = Array.from(uniqueSet).map(JSON.parse)
        return { ...state, selectedTable: uniqueArray }
      }
    },
    selectedRowAction: (state, { payload }) => {
      state.selectedRow = payload
    },
    deleteSelected: (state, { payload }) => {
      const deselected = state.selectedTable.filter((item) => {
        return item?.id !== payload
      })

      state.selectedTable = deselected
    },
    deleteAllSelected: (state) => {
      state.selectedTable = []
      state.selectedRow = []
    },
    // deleteAllSelected: () => ({ ...initialState }),
    deselectSelected: (state, { payload }) => {
      const convertData = payload?.map((item) => ({ ...item, operation: "" }))
      const payloadData = structuredClone(convertData)
      const selectedCards = [...state.selectedTable]

      const ids = new Set(payloadData.map(({ id }) => id))

      const selected = selectedCards.filter(({ id }) => !ids.has(id))

      state.selectedTable = selected
    },
  },

  extraReducers: {
    [FilterConsignment.fulfilled as any]: (state, action) => {
      state.consignments = action.payload
      state.fetchpost = false
    },
    [FilterConsignment.pending as any]: (state) => {
      state.fetchpost = true
    },
    [FilterConsignment.rejected as any]: (state) => {
      state.fetchpost = false
    },
  },
})
export const {
  setFilter,
  selectedTableAction,
  deleteSelected,
  deleteAllSelected,
  deselectSelected,
  selectedRowAction,
} = ConsignmentReducer.actions

export default ConsignmentReducer.reducer
